/** Start a task nobody awaits. The callee reports its own failures, so a rejection here is only
 * swallowed to keep it off the unhandled-rejection channel — `void promise` reads as a code smell. */
export function detach(task: Promise<unknown> | undefined): void {
	task?.catch(() => undefined);
}
